import React from 'react'
import Modal from 'react-bootstrap/Modal'


function Loader({ isLoader }) {
    return (
        <div>
            <Modal
                show={isLoader}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className='loader'
            >
                <Modal.Body>
                    <div className="w-100 d-flex justify-content-center">
                        <div className='text-center'>
                        <img src="img/satellite.svg" alt="Logo" width="56px" height="56px" className="pendulum" />
                        <h5 className='loading-text'>LOADING <span class="bullets">.</span></h5>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Loader
